import HoneyView from '../../components/honeyview/HoneyView'

const HoneyPage = (props) => {
    return <HoneyView {...props} />
}

export default HoneyPage
